module.exports = __webpack_public_path__ + "static/media/buy_pause_payment_1.d25ce193.jpg";